var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",staticStyle:{"position":"relative","top":"10px"}},[_c('i',{staticClass:"el-icon-back",staticStyle:{"font-size":"30px","cursor":"pointer"},on:{"click":function($event){return _vm.back()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }